<template>
<div class="row full-width full-height"
  oncontextmenu="return false"
  @dragenter="listen__x__ondragenter"
  @dragleave="listen__x__ondragleave"
  @dragover="listen__x__ondragover"
  @drop="listen__x__ondrop"
  >

  <div class="full-height">
    <sample-image-list
      :images="sampleImages"
      :title="'샘플 이미지'"
      :caption="sampleImageListCaption"
      @jobstart="showLayer"
      @joberror="(param) => listen__x__onfileerror(param)"
      @jobdone="(file) => preprocessingFile(file)"
    />
  </div>

  <div class="column col full-width full-height" style="padding:10px 30px 25px 30px;">
  <div style="flex:0 0 40px">
    <div class="row" style="padding-bottom: 6px;">
      <div class="row text-h6">
        {{title}}
        <q-btn dense flat icon="help_outline" @click="state.dialogHelp = true" size="xs" style="margin:3px 0px 0px 3px;" v-show="isDev"/>
      </div>
      <q-space />
      <div class="row text-caption" style="align-items:center">
        <health-check-widget
          ref="health-check"
          :functionCheck="healthCheckFunction"
        />
      </div>
    </div>
  </div>
  
  <div style="flex:0 0 15px;" />

  <div class="column bg-white shadow-1 full-width">
    <q-expansion-item icon="camera_alt" label="카메라 열기" class="bg-secondary full-width" default-opened dark expand-icon-class="text-secondary"
      @show="state.dialogCameraCapture.show = true"
      @hide="state.dialogCameraCapture.show = true">
    </q-expansion-item>
  </div>

  <div style="flex:0 0 15px;" />

  <div class="column col bg-white shadow-1 full-width">
    <div class="bg-primary" style="padding:10px 10px;">
      <q-file dark color="white" ref="file" label="파일 업로드..." v-model="compositionFileData.files" dense accept="image/*,.pdf" @input="preprocessingFile">
        <template v-slot:prepend>
          <q-icon name="attach_file" />
        </template>
      </q-file>
    </div>
    <q-separator />
    <q-toolbar>
      <q-btn-group class="image-tool-btn-group" unelevated dense>
        <q-btn unelevated color="primary" icon="fit_screen" label="창에 맞춤" dense no-caps @click="$refs['image-view1'].fitToWindow()" style="padding:0px 5px;" />
        <q-separator vertical />
        <q-btn unelevated color="primary" icon="settings" label="옵션" dense no-caps @click="state.dialogOptions.show = true" style="padding:0px 5px;" />
      </q-btn-group>
      <q-space />
      <q-tabs
        v-model="state.tab"
        indicator-color="primary"
        inline-label
        shrink stretch
      >
        <q-tab name="text" icon="list_alt" label="Text" v-show="false"/>
        <q-tab name="json" icon="account_tree" label="Json" />
      </q-tabs>
    </q-toolbar>
    <q-separator />
    <div class="row col full-height full-width">
      <div class="row col full-height full-width">
        <image-view
          ref="image-view1"
          :frame-data="frameData1"
          :pred="pred"
          class="col full-height full-width"
          :passive="false"
          :initial-tool-option="state.currentFrameToolOption"
          :messages-upload="['\'샘플 이미지\'를 선택,', '\'파일 업로드...\'를 클릭,', '또는 이미지를 여기로 \'드래그\' 하여', '인식을 시작합니다.']"
          @onstatechange="listen__image_view__onstatechange" />
      </div>

      <div class="rtab row full-height full-width" :class="{col: state.tab == 'image'}" style="border-left:1px solid rgb(210, 210, 210);overflow:auto;">
        <q-tab-panels class="row col full-height full-width" v-model="state.tab" animated>
          <q-tab-panel name="text">
            <transition-group
              name="staggered-fade"
              tag="div"
              class="text-area"
              style="flex:1 0 0;"
              v-bind:css="true"
            >
              <BadgePoly v-for="text in searchTexts" :data="text" :key="text.id" @ontoggle="listen__badge__ontoggle" />
            </transition-group>
          </q-tab-panel>
          <q-tab-panel name="json">
            <json-viewer :value="jsonData" :expand-depth=3 copyable></json-viewer>
          </q-tab-panel>
        </q-tab-panels>
      </div>
    </div>
  </div>
</div>

  <camera-capture-dialog v-if="state.dialogCameraCapture.show"
     :resolution="state.dialogCameraCapture.resolution"
     :recognition-type="recognitionType"
    @oncapture="listen__dialogCameraCapture__oncapture"
    @onerror="state.dialogCameraCapture.show = false"
    />

  <q-dialog v-model="state.dialogOptions.show">
    <q-card style="width: 300px" class="q-px-sm q-pb-md">
      <q-card-section>
        <div class="text-h6">옵션</div>
      </q-card-section>

      <q-item-label header>문자영역 선 색</q-item-label>
      <q-item class="row" dense>
        <div class="row col" style="align-items:center;">
          <div :style="{background: state.currentFrameToolOption.lineColor}" style="width:16px;height:16px;border:1px solid black" />
          <span style="margin-left:10px;">{{ state.currentFrameToolOption.lineColor }}</span>
        </div>
        <div class="row col" style="align-items:center;justify-content:flex-end">
          <q-btn-dropdown
            color="primary"
            unelevated
            no-caps
            dense
            label="변경"
            style="padding:0px 10px;"
          >
            <q-color :model-value="state.currentFrameToolOption.lineColor" @change="val => {state.currentFrameToolOption.lineColor = val}" :default-value="state.currentFrameToolOption.lineColor"  class="my-picker" />
          </q-btn-dropdown>
        </div>
      </q-item>
      <div style="height:10px;" />
      <q-item-label header><b>선택된</b> 문자영역 선 색</q-item-label>
      <q-item class="row" dense>
        <div class="row col" style="align-items:center;">
          <div :style="{background: state.currentFrameToolOption.lineHighlightColor}" style="width:16px;height:16px;border:1px solid black" />
          <span style="margin-left:10px;">{{ state.currentFrameToolOption.lineHighlightColor }}</span>
        </div>
        <div class="row col" style="align-items:center;justify-content:flex-end">
          <q-btn-dropdown
            color="primary"
            unelevated
            no-caps
            dense
            label="변경"
            style="padding:0px 10px;"
          >
            <q-color :model-value="state.currentFrameToolOption.lineHighlightColor" @change="val => {state.currentFrameToolOption.lineHighlightColor = val}" :default-value="state.currentFrameToolOption.lineHighlightColor"  class="my-picker" />
          </q-btn-dropdown>
        </div>
      </q-item>
      <div style="height:10px;" />
      <q-item-label header>문자영역 선 두께</q-item-label>
      <q-item class="row" dense>
        <div class="row" style="align-items:center;flex:0 0 50px;">
          <span>{{ parseInt(state.currentFrameToolOption.lineWidth) }}</span>
        </div>
        <div class="row col" style="align-items:center;justify-content:flex-end">
          <q-slider color="teal" v-model="state.currentFrameToolOption.lineWidth" label :min="1" :max="5" :step="1" />
        </div>
      </q-item>
    </q-card>
  </q-dialog>

  <q-dialog v-model="state.dialogHelp">
    <q-card v-if="recognitionType == 'face-mesh'">
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        얼굴 랜드마크 검출 한다.
        <br />
        <span style="font-weight:bold;color:red">추후 설명 보충 필요(michael)</span>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Michael
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>

    <q-card v-if="recognitionType == 'pose-estimation'">
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        사람이 취한 포즈를 검출/추측한다.
        <br />
        <span style="font-weight:bold;color:red">추후 설명 보충 필요(michael)</span>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Michael
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>

    <q-card v-if="recognitionType == 'selfie-segmentation'">
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        장면에서 눈에 띄는 인간을 분할한다.
        <br />
        <span style="font-weight:bold;color:red">추후 설명 보충 필요(michael)</span>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Michael
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>

    <q-card v-if="recognitionType == 'hands'">
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        손의 포즈를 검출/추측한다.
        <br />
        <span style="font-weight:bold;color:red">추후 설명 보충 필요(michael)</span>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Michael
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>

    <q-card v-if="recognitionType == 'pose-estimation'">
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        사람의 자세를 추정한다.
        <br />
        <span style="font-weight:bold;color:red">추후 설명 보충 필요(michael)</span>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Michael
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="OK" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>

    <q-card v-if="recognitionType == 'hair-segmentation'">
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        머리 카락을 분할 합니다.
        <br />
        <span style="font-weight:bold;color:red">추후 설명 보충 필요(michael)</span>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Michael
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="OK" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>

    <q-card v-if="recognitionType == 'hands'">
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        손의 모양과 움직임을 인식한다.
        <br />
        손의 21개 3D 랜드마크를 추론합니다.
        <span style="font-weight:bold;color:red">추후 설명 보충 필요(michael)</span>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Michael
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="OK" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>

    <q-card v-if="recognitionType == 'object-detection'">
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        여러 객체들을 추적한다.
        <br />
        
        <br />
        <span style="font-weight:bold;color:red">추후 설명 보충 필요(michael)</span>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Michael
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="OK" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>

    <q-card v-if="recognitionType == 'iris'">
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        홍채를 추적 한다.
        <br />
        실시간으로 단일 RGB 카메라를 사용하여 홍채, 동공 및 눈 윤곽과 관련된 랜드마크를 추적할 수 있습니다.
        <br />
        <span style="font-weight:bold;color:red">추후 설명 보충 필요(michael)</span>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Michael
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="OK" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>

  <q-inner-loading :showing="state.loadingLayer.show">
    <q-spinner-facebook
        color="primary"
        size="2em"
      />
    {{ state.loadingLayer.message }}
  </q-inner-loading>

  <q-inner-loading :showing="compositionDropData.counterDrag > 0">
    <div class="text-h3">드롭하세요.</div>
  </q-inner-loading>
</div>
</template>


<script>
import compositionDrop from '@/composition/drop.js'
import compositionFile from '@/composition/file.js'

import MixinLayer from '@/mixins/layer.js'

import SampleImageList from '@/components/SampleImageList2.vue'
import ImageView from '@/projects/media/views/ImageView.vue'
import BadgePoly from '@/projects/media/components/BadgePoly.vue'
import HealthCheckWidget from '@/components/healthCheckWidget.vue'
import CameraCaptureDialog from '../components/CameraCaptureDialog.vue'

import PARSE from '@/js/parse.js'
import MISC from '@/js/miscellaneous.js'
import Media from '@/js/media.js'
import MediaDrawing from '@/js/media_drawing.js'

import _ from 'lodash'
import {getCurrentInstance} from '@vue/composition-api'

export default {
  setup () {
    const vm = getCurrentInstance()
    if (null == vm ) {
      return {}
    }
    const {compositionFileData, preprocessingImageFile} = compositionFile(vm)
    function preprocessingFile(data) {
      const file = data instanceof File ? data : data.file
      return preprocessingImageFile(file, vm.proxy.listen__x__onfilechange, vm.proxy.listen__x__onfileerror)
    }
    const {compositionDropData, listen__x__ondragenter, listen__x__ondragleave, listen__x__ondragover, listen__x__ondrop} = compositionDrop(preprocessingFile)
    return {
      compositionDropData,
      listen__x__ondragenter,
      listen__x__ondragleave,
      listen__x__ondragover,
      listen__x__ondrop,
      compositionDrop,
      compositionFileData,
      preprocessingFile
    }
  },
  mixins: [MixinLayer],
  props: ['recognition-type'],
  data: function () {
    return {
      state: {
        dialogHelp: false,
        dialogOptions: {
          show: false
        },
        dialogCameraCapture: {
          show: false,
          resolution: 'vga'
        },
        fitToWindow: false,
        searchText: null,
        tab: 'json',
        currentFrameState: {
          coord: {
            x: 0,
            y: 0
          },
          zoom: undefined,
          voi: {
            windowCenter: 127,
            windowWidth: 256
          }
        },
        currentFrameToolOption: { mouseButtonMask: 2, lineWidth: 2, lineColor: '#ffff00', lineHighlightColor: '#ff0000'},
        bboxShow: true
      },
      sampleImages: [
        {
          document: '사람 1',
          name: 'person_01.jpg',
          url: `${process.env.VUE_APP_URL}/api/image/person_01.jpg`
        },
        {
          document: 'pose 1',
          name: 'body_01.jpg',
          url: `${process.env.VUE_APP_URL}/api/image/body_01.jpg`
        },
        {
          document: '손 1',
          name: 'hand_01.jpg',
          url: `${process.env.VUE_APP_URL}/api/image/hand_01.jpg`
        },
      ],
      fieldInfo: [],
      frameData1: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      frameData2: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      pred: [],
      jsonData: []
    }
  },
  components: {
    SampleImageList,
    ImageView,
    BadgePoly,
    CameraCaptureDialog,
    HealthCheckWidget
  },
  methods: {
    listen__badge__ontoggle: function (e) {
      for (let item of this.searchTexts) {
        if (item.id == e.id) {
          item.highlight = !item.highlight;
        }
      }
      this.updateTagging()
    },
    listen__x__onfilechange: function (file) {
      const Vue = this
      
      Vue.clearData()
      Vue.showLayer('이미지를 읽는 중...');
      
      MISC.doubleRaf(async () => {
        let image;
        let maskImg = null;
        
        let tokens = file.name.split('.');
        let ext = tokens[tokens.length - 1].toLowerCase();
        try {
          image = await PARSE.parseImage(file, ext);
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'purple', message: '이미지 읽기에 실패하였습니다'})
          return
        }
        let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);

        console.log(cornerstoneImage)
        Vue.showLayer('검출 중...');
        let ret = {};
        try {
          if (Vue.recognitionType == 'face-mesh') {
            ret = await Media.processFaceMesh(file, Vue.recognitionType);
            console.log(ret)
            let overlay_img = await MediaDrawing.getFaceMeshImg( document.createElement("canvas"), ret.data, image.width, image.height)
            if (null != overlay_img) {
              maskImg = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, overlay_img.data, overlay_img.width, overlay_img.height);
            }
          } else if (Vue.recognitionType == 'pose-estimation') {
            ret = await Media.processPose(file, Vue.recognitionType);
            console.log(ret)
            let overlay_img = await MediaDrawing.getPoseImg( document.createElement("canvas"), ret.data, image.width, image.height)
            if (null != overlay_img) {
              maskImg = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, overlay_img.data, overlay_img.width, overlay_img.height);
            }
          } else if (Vue.recognitionType == 'selfie-segmentation') {
            ret = await Media.processSelfieSegmentation(file, Vue.recognitionType);
            let base64_img = await PARSE.parseBase64(ret.base64, image.width, image.height, 'jpg')
            maskImg = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, base64_img.pixelData, base64_img.width, base64_img.height);
          } else if (Vue.recognitionType == 'hair-segmentation') {
            ret = await Media.processHairSegmentation(file, Vue.recognitionType);
            let base64_img = await PARSE.parseBase64(ret.base64, image.width, image.height, 'jpg')
            maskImg = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, base64_img.pixelData, base64_img.width, base64_img.height);
          } else if (Vue.recognitionType == 'hands') {
            ret = await Media.processHands(file, Vue.recognitionType);
            let overlay_img = await MediaDrawing.getHandImg( document.createElement("canvas"), ret.data, image.width, image.height)
            if (null != overlay_img) {
              maskImg = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, overlay_img.data, overlay_img.width, overlay_img.height);
            }
          } else if (Vue.recognitionType == 'object-detection') {
            ret = await Media.processObjectDetection(file, Vue.recognitionType);
            let overlay_img = await MediaDrawing.getDetectionImg( document.createElement("canvas"), ret.data, image.width, image.height)
            if (null != overlay_img) {
              maskImg = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, overlay_img.data, overlay_img.width, overlay_img.height);
            }
          } else if (Vue.recognitionType == 'iris') {
            ret = await Media.processIris(file, Vue.recognitionType);
            let overlay_img = await MediaDrawing.getIrisImg( document.createElement("canvas"), ret.data, image.width, image.height)
            if (null != overlay_img) {
              maskImg = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, overlay_img.data, overlay_img.width, overlay_img.height);
            }
          } else {
            throw 'Vue.recognitionType error!!';
          }
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'red', message: err})
          return
        }
        Vue.frameData1 = {
          id: MISC.getUuid4(),
          name: file.name,
          cornerstoneImage,
          maskImg,
          _empty: false
        };
        Vue.pred = ret.pred
        Vue.jsonData = ret.data;
        Vue.hidingLayer()
      });
    },
    listen__x__onfileerror: function (param) {
      const Vue = this

      Vue.jsonData = []
      Vue.compositionFileData.files = []
      Vue.clearData()
      Vue.hidingLayer()

      let color = param.color
      if (color == undefined)
        color = 'black'

      Vue.$q.notify({
        message: param.message,
        icon: 'announcement',
        color
      })
    },
    listen__image_view__onstatechange: function (data) {
      if (data.coord != undefined)
        this.state.currentFrameState.coord = {x: data.coord.x, y: data.coord.y}
      if (data.zoom != undefined)
        this.state.currentFrameState.zoom = data.zoom
      if (data.voi != undefined)
        this.state.currentFrameState.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
      const imageView2 = this.$refs['image-view2']
      if (imageView2 != undefined) {
        imageView2.tostatechange(data)
      }
    },
    listen__btn_bbox__onclick: function () {
      this.state.bboxShow = !this.state.bboxShow;
      
      this.updateTagging()
    },
    listen__dialogCameraCapture__oncapture: function (data) {
      this.state.dialogCameraCapture.resolution = data.resolution
      this.state.dialogCameraCapture.show = false
      if (data.file != undefined) {
        this.listen__x__onfilechange(data.file)
      }
    },
    listen__text_search__oninput: _.debounce(function (e) {
      this.state.searchText = e.target.value
    }, 300),
    clearData: function () {
      this.frameData1 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      this.frameData2 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      this.pred = []
    },
    updateTagging() {
      for (let item of this.pred) {
        const idx = this.searchTexts.findIndex((v) => item.id == v.id);
        if (idx != -1) {
          for (let row of this.pred) {
            if (row.id == item.id)
              row['active'] = this.state.bboxShow
          }
        } else {
          for (let row of this.pred) {
            if (row.id == item.id)
              row['active'] = false
          }
        }
      }

      this.$refs['image-view1'].updateTagging()
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].updateTagging()
    },
    healthCheckFunction: Media.healthCheck,
    getAddress: function () {
      const Vue = this
      return Vue.$refs['health-check'] == undefined ? '' : Vue.$refs['health-check'].getAddress()
    }
  },
  computed: {
    texts: function () {
      return this.pred
    },
    searchTexts: function () {
      if (this.texts.length == 0)
        return [];
      if (this.state.searchText == null || this.state.searchText.length == 0) {
        return this.texts.slice();
      } else {
        let searchTexts = [];
        for (let item of this.pred) {
          if (item.key.indexOf(this.state.searchText) != -1)
            searchTexts.push(item);
        }
        return searchTexts;
      }
    },
    title: function () {
      const Vue = this
      if (Vue.recognitionType == 'face-mesh')
        return 'Face Mesh'
      else if (Vue.recognitionType == 'pose-estimation')
        return 'Pose Estimation'
      else if (Vue.recognitionType == 'selfie-segmentation')
        return 'Selfie Segmentation'
      else if (Vue.recognitionType == 'hair-segmentation')
        return 'Hair Segmentation'
      else if (Vue.recognitionType == 'object-detection')
        return 'Object Detection'
      else if (Vue.recognitionType == 'hands')
        return 'Hands'
        else if (Vue.recognitionType == 'iris')
        return 'Iris'
      else
        return ''
    },
    sampleImageListCaption: function () {
      return this.sampleImages.map((v) => v.document).join(', ')
    }
  },
  watch: {
    searchTexts: function () {
      this.updateTagging()
    },
    'state.currentFrameToolOption.lineColor': function (value) {
      this.$refs['image-view1'].setToolOption('lineColor', value)
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].setToolOption('lineColor', value)
    },
    'state.currentFrameToolOption.lineHighlightColor': function (value) {
      this.$refs['image-view1'].setToolOption('lineHighlightColor', value)
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].setToolOption('lineHighlightColor', value)
    },
    'state.currentFrameToolOption.lineWidth': function (value) {
      this.$refs['image-view1'].setToolOption('lineWidth', value)
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].setToolOption('lineWidth', value)
    },
  },
  async mounted () {
    const Vue = this
    Vue.$refs['health-check'].listen__healthcheck__onclick()
  }
}
</script>

<style scoped>
.rtab:not(.col) {
  flex: 0 0 400px;
}

@media (max-width: 1000px) {
  .image-tool-btn-group {
    display: none !important;
  }
}
</style>